export enum BillingStates {
	created = 0,
	ReportGenerated = 1,
	QuoteGenerated = 2,
	QuoteUpdated = 3,
	QuoteRejeced = 4,
	QuoteApproved = 5,
	InvoiceGenerated = 6,
	InvoiceUpdated = 7,
	InvoiceRejected = 8,
	InvoiceApproved = 9,
	Done = 10
}
